import type { Severity } from '@smartapply/shared';

interface ItemIdProps {
  prefix: 'F' | 'S' | 'Q' | 'R';
  index: number;
  severity?: Severity;
}

/**
 * Identificador de item em mono pesada (E4 do docs/01 §6).
 *
 * Prefixo da categoria + número zero-padded:
 *   F.01, F.02 — Findings (problemas)
 *   S.01, S.02 — Strengths (forças)
 *   Q.01, Q.02 — Quick wins
 *   R.01, R.02 — Rewrites (reescritas)
 *
 * A cor opcionalmente segue a severity, mas em opacity baixa para não
 * competir com o título do item.
 */
export function ItemId({ prefix, index, severity }: ItemIdProps) {
  const color = colorOf(severity);
  return (
    <span
      className="font-mono text-[11px] font-semibold uppercase tracking-wider tabular-nums"
      style={{ color }}
    >
      {prefix}.{index.toString().padStart(2, '0')}
    </span>
  );
}

function colorOf(severity?: Severity): string {
  switch (severity) {
    case 'critical':
      return 'var(--accent-crimson)';
    case 'positive':
      return 'var(--accent-forest)';
    case 'suggestion':
      return 'var(--accent-saffron)';
    default:
      return 'var(--ink-tertiary)';
  }
}
